import * as Yup from 'yup';

export default Yup.object().shape({
  otp: Yup.string().required('Please enter otp')
});
